<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="M3 17c-.6-.5-.6-1.5 0-2l8-8c.5-.6 1.5-.6 2 0l8 8a1.5 1.5 0 0 1-2 2l-7-6.9-7 7c-.5.5-1.5.5-2 0"
    />
  </svg>
</template>
